import { DrawerLink } from "./drawer-link";

export class DrawerLinkWrapper {
	Top: DrawerLink[] = [];
	Contacts: DrawerLink[] = [];
	Products: DrawerLink[] = [];
	Sales: DrawerLink[] = [];
	Buy: DrawerLink[] = [];
	Financial: DrawerLink[] = [];
	Tools: DrawerLink[] = [];
	Bottom: DrawerLink[] = [];

	public constructor(data?: any) {
		if (!data) return;
		this.Top = (data.Top || []).map((d: any) => new DrawerLink(d));
		this.Contacts = (data.Contacts || []).map((d: any) => new DrawerLink(d));
		this.Products = (data.Products || []).map((d: any) => new DrawerLink(d));
		this.Sales = (data.Sales || []).map((d: any) => new DrawerLink(d));
		this.Buy = (data.Buy || []).map((d: any) => new DrawerLink(d));
		this.Financial = (data.Financial || []).map((d: any) => new DrawerLink(d));
		this.Tools = (data.Tools || []).map((d: any) => new DrawerLink(d));
		this.Bottom = (data.Bottom || []).map((d: any) => new DrawerLink(d));
	}

	public getLinksForGroup(groupKey: string): DrawerLink[] {
		return (this as any)[groupKey] || [];
	}

	public findByUid(uid: string): DrawerLink | undefined {
		const allLinks = [
			...this.Top,
			...this.Contacts,
			...this.Products,
			...this.Sales,
			...this.Buy,
			...this.Financial,
			...this.Tools,
			...this.Bottom
		];
		return allLinks.find(l => l.uid === uid);
	}

	public getJSON() {
		return {
			Top: this.Top.map(l => l.getJSON()),
			Contacts: this.Contacts.map(l => l.getJSON()),
			Products: this.Products.map(l => l.getJSON()),
			Sales: this.Sales.map(l => l.getJSON()),
			Buy: this.Buy.map(l => l.getJSON()),
			Financial: this.Financial.map(l => l.getJSON()),
			Tools: this.Tools.map(l => l.getJSON()),
			Bottom: this.Bottom.map(l => l.getJSON())
		};
	}
}
